import React from 'react';
import {observer} from 'mobx-react';
import { extendObservable } from 'mobx';
import { Header, Input,Container, Button, Message, Form } from 'semantic-ui-react';

import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag'

class CreateTeam extends React.Component{
    constructor(props) {
        super(props);
        extendObservable(this,{
            name:'',
            errors:{},
        });
    }
    onChange=(e) => {
        const {name,value}=e.target;
        this[name]=value;
    };
    onSubmit=async()=>{
        const {name}=this;
        var name1=name.toString().trim();
        if(name1.length==0) {return}

        let response=null;
        try{
            response=await this.props.mutate({
                variables:{name1},
            });
        }catch(e){
            console.log(e);
            this.props.history.push('/login');
            return;
        }
        // console.log(response);
        const {ok,errors,team}=response.data.createTeam;

        if(ok){
            this.props.history.push(`/view-team/${team.id}`);
        }else{
            const err={};
            errors.forEach(({path,message})=>{
                err[`${path}Error`] = message;
            });
            this.errors=err;
        }
    };
    render(){
        const {name,errors:{nameError}} = this;
        const errorList=[];

        if(nameError){
            errorList.push(nameError);
        }
        return (
            <Container text>
                <br/>
                <Form>
                    <Form.Field>
                        <Header as="h2">Team Up</Header>
                    </Form.Field>
                    <Form.Field error={!!nameError}>
                        <Input  name="name" onChange={this.onChange} value={name} placeholder="Name" fluid />
                    </Form.Field>
                    <Form.Field> 
                        <Button onClick={this.onSubmit}>Create</Button>
                    </Form.Field>
                </Form>
                { nameError ?(
                        <Message
                            error
                            list={errorList}
                        />
                    ) : null}
            </Container>
        );
    }
    
};
const createTeamMutation=gql`
    mutation($name1:String!){
        createTeam(name:$name1){
            ok
            team{
                id
            }
            errors{
                path
                message
            }
        }
    }
`;

export default graphql(createTeamMutation)(observer(CreateTeam));